const previouslyScannedLpnHtml = require("./html/previouslyScannedLPN.html");
const lpnSkuHtml = require("./html/lpnSku.html");
const lpnsToScanMessageHtml = require("./html/lpnsToScanMessage.html");

import run from '../../utilities/run';
import {hide, show} from '../../utilities/selectorHelpers';
import $ from 'jquery';
import _ from "underscore";

require("./amazonLPNScan.less");

run("#scan-lpns-page", ()=> {
  const scanLpnsPage = $("#scan-lpns-page");
  const scanLpnSection = $("#scan-lpn-section");
  const getPackageLabelSection = $("#get-package-label-section");
  const markShipWarning = $("#mark-ship-warning");
  const markShipButtonSection = $("#mark-ship-button-section");
  const lpnDetailsSection = $("#lpn-details-section");
  const amazonConnectionError = $("#amazon-connection-error");
  const getLabelFromAmazonButton = $("#get-label-from-amazon-btn");
  const gettingLabelFromAmazonBar = $("#getting-label-from-amazon-bar");
  const returnToPalletSearchSection = $("#return-to-pallet-search-section");
  const previouslyScannedSection = $("#previously-scanned-section");
  const lpnsToScanFirstMessage = $("#lpns-to-scan-first-message");
  const lpnsToScanNextMessage = $("#lpns-to-scan-next-message");
  const lpnAlreadyScannedWarning = $("#lpn-already-scanned-warning");
  const lpnNotInPalletWarning = $("#lpn-not-in-pallet-warning");
  const lpnScanningError = $("#error-scanning-lpn");
  const noLPNsProcessedWarning = $("#no-lpns-processed-warning");
  const lpnToScan = $("#lpn-to-scan");
  const scanLpnButton = $("#scan-lpn-btn");
  const displayLpnNumber = $("#lpn-number-display");
  const shippingType=scanLpnsPage.data('shipping-type');
  const scanLpnUrl = scanLpnsPage.data("scan-lpn-url");
  const getLabelFromAmazonUrl = scanLpnsPage.data("get-label-from-amazon-url");
  const getAmazonLabelUrl = scanLpnsPage.data("get-amazon-label-url");

  const orderId = scanLpnsPage.data("order-id");
  const palletNumber = scanLpnsPage.data("pallet-number");
  const lpns = scanLpnsPage.data("lpns");
  const readyToShip = scanLpnsPage.data("ready-to-ship");
  const totalLpns = scanLpnsPage.data("number-of-lpns");
  let numberOfLpnsToScan = totalLpns;

  initializePage();

  function initializePage() {
    checkForPreviouslyScannedLpns(lpns);
    if (totalLpns === numberOfLpnsToScan) {
      setDisplayForNoScannedLpns();
    } else if (numberOfLpnsToScan == 0) {
      setDisplayForAllScannedLpns();
    } else {
      setDisplayForSomeScannedLpns();
    }
  }

  function checkForPreviouslyScannedLpns(lpns) {
    _.each(lpns, processPreviouslyScannedLpn);
  }

  function processPreviouslyScannedLpn(lpn, index, list) {
    if (lpn.hasLabel === true) {
      numberOfLpnsToScan = numberOfLpnsToScan - 1;
      addLpnToPreviouslyScannedSection(lpn.olmLpnNumber);
    }
  }

  function setDisplayForNoScannedLpns() {
    show(scanLpnSection);
    hide(getPackageLabelSection);
    hide(markShipWarning);
    hide(markShipButtonSection);
    hide(returnToPalletSearchSection);
    hide(lpnsToScanNextMessage);
    hide(lpnAlreadyScannedWarning);
    hide(lpnNotInPalletWarning);
    hide(lpnScanningError);
  }

  function setDisplayForSomeScannedLpns() {
    show(scanLpnSection);
    setLpnsToScanMessageHtml();
    hide(getPackageLabelSection);
    hide(markShipWarning);
    hide(markShipButtonSection);
    hide(returnToPalletSearchSection);
    hide(lpnsToScanFirstMessage);
    hide(lpnAlreadyScannedWarning);
    hide(lpnNotInPalletWarning);
    hide(lpnScanningError);
    hide(noLPNsProcessedWarning);
  }

  function setDisplayForAllScannedLpns() {
    hide(scanLpnSection);
    hide(getPackageLabelSection);
    hide(lpnsToScanFirstMessage);
    hide(lpnsToScanNextMessage);
    hide(lpnAlreadyScannedWarning);
    hide(lpnNotInPalletWarning);
    hide(lpnScanningError);
    hide(noLPNsProcessedWarning);
    if (readyToShip == true) {
      hide(markShipWarning);
      hide(markShipButtonSection);
      show(returnToPalletSearchSection);
    } else {
      hide(returnToPalletSearchSection);
      show(markShipWarning);
      show(markShipButtonSection);
    }
  }

  scanLpnButton.click(function() {
    scanLpn(lpnToScan.val());
  });

  function scanLpn(lpnNumber) {
    const lpnIsValid = validateLpnToScan(lpnNumber);
    if (lpnIsValid) {
      displayLpnNumber.text(lpnNumber);
      callScanLpn(lpnNumber);
    }
  }

  function validateLpnToScan(lpnNumber) {
    if (checkLpnIsInPallet(lpnNumber)) {
      if (checkLpnIsNotScanned(lpnNumber)) {
        return true;
      } else {
        showScanLpnError(lpnAlreadyScannedWarning);
      }
    } else {
       showScanLpnError(lpnNotInPalletWarning);
    }
    return false;
  }

  function checkLpnIsInPallet(lpnNumber) {
    return _.contains(_.pluck(lpns, 'olmLpnNumber'), lpnNumber);
  }

  function checkLpnIsNotScanned(lpnNumber) {
    const index = _.indexOf(_.pluck(lpns, 'olmLpnNumber'), lpnNumber);
    return lpns[index].hasLabel === false;
  }

  function showScanLpnError(el) {
    hide(lpnsToScanFirstMessage);
    hide(lpnsToScanNextMessage);
    hide(lpnScanningError);
    hide(lpnNotInPalletWarning);
    hide(lpnAlreadyScannedWarning);
    show(el);
  }

  function callScanLpn(lpnNumber) {
    $.ajax({
      url: scanLpnUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        palletNumber: palletNumber,
        lpnNumber: lpnNumber,
        shippingType:shippingType
      },
      success: processScanLpnResponse,
      error: handleScanLpnError
    });
  }

  function processScanLpnResponse(data) {
    if(data.response === 'failed') {
      handleScanLpnError();
    } else {
      handleScanLpnSuccess(data);
    }
  }

  function handleScanLpnSuccess(data) {
    lpnDetailsSection.html('');
    _.each(data, processLpnDetail);
    hide(scanLpnSection);
    show(getPackageLabelSection);
    show(getLabelFromAmazonButton);
    hide(amazonConnectionError);
    hide(gettingLabelFromAmazonBar);
  }

  function processLpnDetail(lpnDetail, index, list) {
    addSkuToLpnDetailsSection(lpnDetail.olmItmSku , lpnDetail.olmPackedQty);
  }

  function handleScanLpnError() {
    hide(lpnsToScanFirstMessage);
    hide(lpnsToScanNextMessage);
    hide(lpnAlreadyScannedWarning);
    hide(lpnNotInPalletWarning);
    show(lpnScanningError);
  }

  getLabelFromAmazonButton.click(function() {
    getLabelFromAmazon(displayLpnNumber.text());
  });

  function getLabelFromAmazon(lpnNumber) {
    hide(getLabelFromAmazonButton);
    show(gettingLabelFromAmazonBar);
    callGetLabelFromAmazon(lpnNumber);
  }

  function callGetLabelFromAmazon(lpnNumber) {
    $.ajax({
      url: getLabelFromAmazonUrl,
      type: 'POST',
      dataType: 'TEXT',
      data: {
        palletNumber: palletNumber,
        lpnNumber: lpnNumber,
        orderId: orderId
      },
      success: processGetLabelFromAmazonResponse,
      error: handleGetLabelFromAmazonError
    });
  }

  function processGetLabelFromAmazonResponse(data) {
    if (data === 'success') {
      handleGetLabelFromAmazonSuccess(displayLpnNumber.text());
    } else {
      handleGetLabelFromAmazonError();
    }
  }

  function handleGetLabelFromAmazonSuccess(lpnNumber) {
    flagLpnAsScanned(lpnNumber);
    addLpnToPreviouslyScannedSection(lpnNumber);
    numberOfLpnsToScan = numberOfLpnsToScan - 1;
    if (numberOfLpnsToScan == 0) {
      setDisplayForAllScannedLpns();
    } else {
      lpnToScan.val('');
      show(lpnsToScanNextMessage);
      setDisplayForSomeScannedLpns();
    }
  }

  function flagLpnAsScanned(lpnNumber) {
    const index = _.indexOf(_.pluck(lpns, 'olmLpnNumber'), lpnNumber);
    lpns[index].hasLabel = true;
  }

  function handleGetLabelFromAmazonError() {
    show(amazonConnectionError);
    show(getLabelFromAmazonButton);
    hide(gettingLabelFromAmazonBar);
    hide(lpnDetailsSection);
  }

  $(document).on("click", '.print-pkg-label-btn', function(e) {
    e.preventDefault();
    const lpn = $(this).data('lpn-number');
    printPackageLabel(lpn);
  })

  function printPackageLabel(lpnNumber) {
    const url = getAmazonLabelUrl.concat('&fileName=label.pdf&lpnNumber=').concat(lpnNumber);
    let labelWindow = window.open(url, 'label-'.concat(lpnNumber));
    labelWindow.document.title = 'Package Label';
  }

  function setLpnsToScanMessageHtml() {
    const htmlTemplate = _.template(lpnsToScanMessageHtml);
    lpnsToScanNextMessage.html(htmlTemplate({numberOfLpns: numberOfLpnsToScan}))
  }

  function addLpnToPreviouslyScannedSection(lpnNumber) {
    const htmlTemplate = _.template(previouslyScannedLpnHtml);
    previouslyScannedSection.append(htmlTemplate({lpnNumber : lpnNumber}));
  }

  function addSkuToLpnDetailsSection(sku, quantityPacked) {
    const htmlTemplate = _.template(lpnSkuHtml);
    lpnDetailsSection.append(htmlTemplate({productSku: sku, quantityPacked: quantityPacked}));
  }

});



// WEBPACK FOOTER //
// ./src/pages/amazon/scanLPNs.js